var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967L14.2676 9.20693L14.2891 9.22846C14.6668 9.60615 14.9821 9.9214 15.2186 10.2C15.4653 10.4906 15.67 10.7902 15.787 11.1502C15.9664 11.7025 15.9664 12.2975 15.787 12.8498C15.67 13.2098 15.4653 13.5094 15.2186 13.8C14.9821 14.0786 14.6668 14.3938 14.2891 14.7715L14.2676 14.7931L10.5303 18.5303C10.2374 18.8232 9.76256 18.8232 9.46967 18.5303C9.17678 18.2374 9.17678 17.7626 9.46967 17.4697L13.2069 13.7324C13.6117 13.3276 13.883 13.0556 14.0751 12.8292C14.2615 12.6096 14.329 12.4829 14.3604 12.3863C14.442 12.1352 14.442 11.8648 14.3604 11.6137C14.329 11.5171 14.2615 11.3904 14.0751 11.1708C13.883 10.9444 13.6117 10.6724 13.2069 10.2676L9.46967 6.53033C9.17678 6.23744 9.17678 5.76256 9.46967 5.46967Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.2d58ff9686192eae3155f0ed76b5ae19.svg";
export { ForwardRef as ReactComponent };